// src/services/budgetCategoryService.js
import api from '../config/axios';

const BASE_PATH = '/budget-categories';

// ============= Query Operations =============

/**
 * Get all budget categories
 */
export const getAllCategories = async () => {
  const response = await api.get(BASE_PATH);
  return response.data;
};

/**
 * Get budget category by ID
 */
export const getCategoryById = async (id) => {
  const response = await api.get(`${BASE_PATH}/${id}`);
  return response.data;
};

/**
 * Get all categories by project type
 */
export const getCategoriesByProjectType = async (projectType) => {
  const response = await api.get(`${BASE_PATH}/project-type/${projectType}`);
  return response.data;
};

/**
 * Get root categories tree by project type
 */
export const getRootCategoriesTree = async (projectType) => {
  const response = await api.get(`${BASE_PATH}/project-type/${projectType}/tree`);
  return response.data;
};

/**
 * Get children of a category
 */
export const getChildrenByParentId = async (parentId) => {
  const response = await api.get(`${BASE_PATH}/${parentId}/children`);
  return response.data;
};

/**
 * Get leaf categories (can add BOQ) by project type
 */
export const getLeafCategories = async (projectType) => {
  const response = await api.get(`${BASE_PATH}/project-type/${projectType}/leaves`);
  return response.data;
};

/**
 * Search categories by code or name
 */
export const searchCategories = async (query) => {
  const response = await api.get(`${BASE_PATH}/search`, {
    params: { q: query }
  });
  return response.data;
};

/**
 * Advanced search with filters
 */
export const advancedSearchCategories = async (filters = {}) => {
  const response = await api.get(`${BASE_PATH}/search/advanced`, {
    params: {
      projectType: filters.projectType || undefined,
      level: filters.level !== undefined ? filters.level : undefined,
      isGroup: filters.isGroup !== undefined ? filters.isGroup : undefined,
      canAddDirect: filters.canAddDirect !== undefined ? filters.canAddDirect : undefined,
      q: filters.query || undefined
    }
  });
  return response.data;
};

// ============= Command Operations =============

/**
 * Create new budget category
 */
export const createCategory = async (categoryData) => {
  const response = await api.post(BASE_PATH, categoryData);
  return response.data;
};

/**
 * Update existing budget category
 */
export const updateCategory = async (id, categoryData) => {
  const response = await api.put(`${BASE_PATH}/${id}`, categoryData);
  return response.data;
};

/**
 * Soft delete budget category
 */
export const softDeleteCategory = async (id) => {
  await api.delete(`${BASE_PATH}/${id}`);
};

/**
 * Restore soft deleted category
 */
export const restoreCategory = async (id) => {
  await api.post(`${BASE_PATH}/${id}/restore`);
};

// ============= Export Default =============

export default {
  getAllCategories,
  getCategoryById,
  getCategoriesByProjectType,
  getRootCategoriesTree,
  getChildrenByParentId,
  getLeafCategories,
  searchCategories,
  advancedSearchCategories,
  createCategory,
  updateCategory,
  softDeleteCategory,
  restoreCategory
};